module.exports = require('./helpers/bundle-url').getBundleURL('lbB2N') + "admin-scrollbar-up-icon.dd55db30.svg";